import React from "react";
import profileImg from "../../../cv/assets/img.jpeg";
import { MdArrowDownward, MdArrowBack } from "react-icons/md";
import { Link } from "gatsby";

const Head: React.FC = () => {
  return (
    <div className="bg-gray-700 p-10 flex flex-col items-center text-gray-50 font-light pb-10 relative">
      <Link
        to="/"
        style={{ color: "inherit", textDecoration: "inherit" }}
        className="rounded-xl p-5 absolute left-5 top-5 flex align-items cursor-pointer bg-transparent hover:bg-white hover:bg-opacity-10 bg-opacity-10"
      >
        <MdArrowBack size={25} className="mr-2 text-gray-50" /> Back
      </Link>
      <img src={profileImg} className="w-48 h-48 rounded-full " />
      <div
        style={{ letterSpacing: "0.4rem" }}
        className="text-5xl font-bold text-center"
      >
        I CREATE WEB APPS 🚀
      </div>
      <div className="text-2xl font-semibold text-gray-300 mt-10 text-center">
        I'm a fullstack developer.
      </div>
      <div className="text-xl text-gray-300 mt-6 text-center w-6/12">
        From what user sees 👀 <span className="mr-1" /> through backend coding
        🗄️ <span className="mr-1" /> to designing database models 📊
      </div>
      <div className="opacity-30 mt-10 w-11/12 sm:w-6/12 text-center leading-tight border p-5 rounded-md">
        Javascript Typescript React Redux Context Hooks dnd CSS3 Flex Grid
        css-variables css-modules styled-components tailwind GatsbyJS Node.js
        Express AWS Lambda DynamoDB S3 Serverless PostgreSQL GraphQL N+1
        dataloader
      </div>
      <div className="mt-24 mb-10 font-medium text-lg">
        See some of my shots 🔫
      </div>
      <MdArrowDownward size={40} className="animate-bounce" />
    </div>
  );
};

export default Head;
